// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__FQ9BS","loaderOuter":"PageOverlayLoader_loaderOuter__9UAhX"};